var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeviceNoteHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_device_note_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_device_note_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.00247329 C0,1.34778288 1.54007503,0 3.42331151,0 L12.5766885,0 C14.470729,0 16,1.35406674 16,3.00247329 L16,12.9975267 C16,14.6522171 14.459925,16 12.5766885,16 L3.42331151,16 C1.52927098,16 0,14.6459333 0,12.9975267 L0,3.00247329 Z",
    id: "Path",
    fill: "#5697B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5810203,15 C9.80632657,17 9.80632657,18 10.5810203,18 C11.355714,18 13.0223807,17 15.5810203,15 L10.5810203,15 Z",
    id: "Path-2",
    fill: "#5697B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,3.00247329 L2,12.9975267 C2,13.544239 2.53478561,14 3.19447708,14 L12.8055229,14 C13.4532027,14 14,13.5511774 14,12.9975267 L14,3.00247329 C14,2.45576096 13.4652144,2 12.8055229,2 L3.19447708,2 C2.54679728,2 2,2.44882258 2,3.00247329 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    fill: "#5697B7",
    x: 4,
    y: 4,
    width: 8,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    fill: "#5697B7",
    x: 4,
    y: 10,
    width: 8,
    height: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceNoteHover);
export default __webpack_public_path__ + "static/media/icon_device_note_hover.2d12a2ddadb4ef443975b98f9fff29bf.svg";
export { ForwardRef as ReactComponent };